import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const LocationCard = ({ lat, lon }) => {
  const [locationInfo, setLocationInfo] = useState(null);

  useEffect(() => {
    const fetchLocationDetails = async () => {
      if (!lat || !lon) return;
      try {
        const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&zoom=18&addressdetails=1`;
        const res = await fetch(url);
        const data = await res.json();
        if (data && data.address) {
          setLocationInfo({
            road: data.address.road || '',
            suburb: data.address.suburb || '',
            city: data.address.city || data.address.town || '',
            state: data.address.state || '',
            postcode: data.address.postcode || '',
            display_name: data.display_name,
          });
        }
      } catch (err) {
        console.error('Reverse geocoding failed:', err);
      }
    };
    fetchLocationDetails();
  }, [lat, lon]);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">📍 Location</Typography>
        
        {locationInfo ? (
          <>
		  <Typography variant="body2">Lat/Lon: {lat?.toFixed(5)}, {lon?.toFixed(5)}</Typography>
            <Typography variant="body2">Street: {locationInfo.road}</Typography>
            <Typography variant="body2">Town: {locationInfo.city}, {locationInfo.state} {locationInfo.postcode}</Typography>
            
          </>
        ) : (
          <Typography variant="subtitle1" color="textSecondary">
            Tap <strong>Use My Location</strong> above or enter an address to set your position.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default LocationCard;
